export const defaultThemeColors = Object.freeze({
  primary: '#559a1b',
  secondary: '#165039'
})
